import { inject, watch } from "aurelia";
import { User } from '@nhost/nhost-js';
import { IDialogService } from '@aurelia/dialog';
import { IRouteableComponent, IRouter, routes } from '@aurelia/router';
import { initCollapses, initDropdowns } from 'flowbite';
import { IAuthService } from '@interfaces/auth-service/auth-service-interface';
import { IZeusClient, ZeusClient } from '@services/graphql-service/zeus-client';
import { appRoutes } from '../common/routers/app-route';
import "driver.js/dist/driver.css";
import { ModelTypes } from "@zeus";
import { Onboarding } from "@components/onboarding/onboarding";

@routes(appRoutes)
@inject(IRouter, IAuthService, IZeusClient, IDialogService)
export class MyApp implements IRouteableComponent {

  private isOpenDrawer: boolean = true;
  private trialExpirationText: string;
  private buttonText: string;
  private isOpenTestMessage: boolean = true;

  private onboardDialog

  constructor(
    private router: IRouter,
    private auth: IAuthService,
    private zeusClient: ZeusClient,
    private dialogService: IDialogService,
  ) { }

  attached() {
    initCollapses();
    initDropdowns();

    this.zeusClient.userDetailsSubscription();
    this.zeusClient.getUserSubscription();
  }

  @watch('auth.user')
  handleUser(newValue: User, oldValue: User) {
    if (newValue && newValue !== oldValue) {
      this.zeusClient.userDetailsSubscription();
    }
  }

  @watch('zeusClient.userDetails')
  async handleUserDetailsSubscription(newValue: ModelTypes['userMetadata']) {
    if (typeof newValue?.onboardCompleted === 'undefined') return;

    this.handleUserDetails(newValue)

    const modal = document.getElementById('user-onboarding-modal')

    if (newValue?.onboardCompleted === false && !modal) {
      const { dialog } = await this.dialogService.open({
        component: () => Onboarding,
        model: {},
        lock: true,
        startingZIndex: 100,
      });

      this.onboardDialog = dialog;

      const result = await dialog.closed;

      if (result.status === 'ok') {
        this.onboardDialog = null;
      }

    }
  }

  handleUserDetails(newUserMetadata: ModelTypes['userMetadata']) {
    const trialEndsAt = newUserMetadata?.trialEndDate;

    if (this.auth.user.defaultRole == 'user-freetrial' || this.auth.user.defaultRole == 'user') {
      if (trialEndsAt) {
        const trialEndsAtDate = new Date(trialEndsAt);
        const currentDate = new Date();
        const daysLeft = Math.floor((trialEndsAtDate.getTime() - currentDate.getTime()) / (1000 * 60 * 60 * 24));

        if (daysLeft == 7) {
          this.trialExpirationText = 'Desbloqueie agora o poder absoluto da magia, com imagens e posts ilimitados!';
          this.buttonText = 'Ativar agora';
        } else if (daysLeft < 7 && daysLeft >= 0) {
          this.trialExpirationText = `Não perca sua magia! Ganhe o poder da IA ilimitada antes do teste acabar.`;
          this.buttonText = 'Liberar poder';
        } else if (daysLeft < 0) {
          this.trialExpirationText = 'O teste acabou, mas a magia está só começando. O poder da IA ainda pode ser seu!';
          this.buttonText = 'Recuperar a magia';
        }
      }
    }

  }

  closeMessage() {
    this.isOpenTestMessage = false;
    this.trialExpirationText = 'Teste gratuito';
  }

  async handleAccountSubscription(newValue: User) {
    if (!newValue) return;

    this.zeusClient.getUserSubscription()
  }
}
